<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
        <div class="back-outer mobile-back" routerLink="/">
  <p>Back to home</p>
</div>
<div class="login-sec grid m-0">
    <p-image src="assets/images/login-truck.png" alt="Image" width="200" class="img-truck"></p-image>
    <div class="common-password-outer login-left col-12 lg:col-6 ">
        <div class="logo-sec text-center" routerLink="/">
            <p-image class="custom-logo" href="/" src="assets/images/logo-white.svg" alt="Image"></p-image>
            <h1 class="mb-0 text-white">The Evolution</h1>
            <p class="mt-0 text-white mb-0 mb-lg-5">of Parking Tracking</p>
        </div>
    </div>
    <div class="login-right col-12 lg:col-6 flex">
        <form [formGroup]="loginForm">
            <h3>Login</h3>
            <div class="email-outer">
                <div class="flex flex-column  bottom-space formgrid">
                    <div class="mobile-tooltip">
                        <label htmlFor="username">Username</label>
                        <app-tooltip [tooltipMessage]="mobileMsg"></app-tooltip>
                    </div>
                    <input pInputText id="username"
                        [class.ng-invalid]="loginForm.get('email')?.hasError('required')  && (loginForm.get('email')?.dirty || loginForm.get('email')?.touched)"
                        [class.ng-dirty]="loginForm.get('email')?.hasError('required')  && (loginForm.get('email')?.dirty || loginForm.get('email')?.touched)"
                        placeholder="Enter Username" aria-describedby="username-help" formControlName='email' />
                    <small id="username-help" class="hidden">Enter your username to reset your password.</small>
                    <div
                        *ngIf="loginForm.get('email')?.hasError('required')  && (loginForm.get('email')?.dirty || loginForm.get('email')?.touched)">
                        <div class="validation-error"> This field is required*</div>
                    </div>
                    <div
                        *ngIf="loginForm.get('email')?.hasError('invalidEmail') && (loginForm.get('email')?.dirty || loginForm.get('email')?.touched)">
                        <div class="validation-error"> Please enter a valid email*</div>
                    </div>
                    <div
                        *ngIf="loginForm.get('email')?.hasError('invalidPhone') && (loginForm.get('email')?.dirty || loginForm.get('email')?.touched)">
                        <div class="validation-error"> Please enter a valid mobile number*</div>
                    </div>
                </div>
                <div class="flex flex-column formgrid">
                    <label htmlFor="password">Password</label>
                    <p-password class="pass-input"
                        [class.ng-invalid]="loginForm.get('password')?.hasError('required')  && (loginForm.get('password')?.dirty || loginForm.get('password')?.touched)"
                        [class.ng-dirty]="loginForm.get('password')?.hasError('required')  && (loginForm.get('password')?.dirty || loginForm.get('password')?.touched)"
                        placeholder="Enter Password" [feedback]=false indicator="false" [toggleMask]="true"
                        formControlName='password' id="password"></p-password>
                    <div
                        *ngIf="loginForm.get('password')?.hasError('required')  && (loginForm.get('password')?.dirty || loginForm.get('password')?.touched)">
                        <div class="validation-error"> This field is required*</div>
                    </div>
                </div>
            </div>
            <div class="flex justify-content-between gap-2 my-36">
                <span class="flex align-items-center gap-1">
                    <p-checkbox formControlName="rememberMe" [binary]="true" value="" inputId="ny"></p-checkbox>
                    <label for="rememberMe" class="sub-label">Remember Me</label>
                </span>
                <div class="password-text">
                    <p><a (click)="resetPassword()">Forgot Password?</a></p>
                </div>
            </div>
            <div class="flex flex-column gap-2">
                <p-button type="submit" label="Sign In" class="w-100" (onClick)="login()"></p-button>
            </div>
            <div class="create-account">
                <p>Don’t have an account? <a (click)="redirectToLanding()">Signup</a>
                </p>
            </div>
        </form>
    </div>
</div>
